import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorNewsList extends InternalStaticAnchor {
	/**
	 * @type {string}
	 * @private
	 */
	_pattern = '/news/list';
}
